export default {
  'menu.settings.workflow': 'Approval Workflows',
  'menu.settings.businessProcess': 'Business Process Configuration',
  'menu.funds.operations': '基金资金与运营',
  'menu.funds.disclosure': '基金备案与信息披露',
  'menu.funds.distribution': '收益分配与清算',
  'menu.home.overview': '概览',
  'menu.funds.overview': '概览',
  'menu.investment.overview': '概览',
  'menu.portfolio.overview': '概览',
  'menu.research.overview': '概览',
  'menu.portfolio.exit.overview': '概览',

  'menu.settings.investmentFlow': 'Business Process & Approval Config',
  'menu.settings.projectManagerRiskMapping': 'Manager and Risk Management',
  'menu.settings.fundDictionary': '基金业务字典',
  'menu.settings.portfolioConfig': '投后业务配置',
  'menu.settings.exitConfig': '退出业务配置',
  'menu.settings.researchConfig': '投研业务配置',

  'menu.analysis.fundPerformance': '基金业绩',
  'menu.analysis.portfolioAnalysis': '组合分析',
  'menu.analysis.investmentAnalysis': '投资项目分析',
  'menu.analysis.exitAnalysis': '退出回收分析',

  'menu.home.myWorkbench': '工作台',
  'menu.home.tasks': '待办与审批',
  'menu.home.focus': '关注对象',
  'menu.home.schedule': '日程安排',
  'menu.home.activity': '动态',
  'menu.home.risk': '风险与履约',
  'menu.home.LP 基金': 'LP Funds',
  'menu.home.基金协作': 'Fund Collaboration',
  'menu.analysis.overview': '概览',
  'menu.analysis.trace': '资金权益追溯',

  'menu.funds.总览': '总览',
  'menu.funds.基金': '基金',
  'menu.funds.基金.基金列表': '基金列表',
  'menu.funds.基金.投资联动': '投资联动',
  'menu.funds.基金.基金详情': '基金详情',
  'menu.funds.主体档案': '主体档案',
  'menu.funds.募资跟进': '募资跟进',
  'menu.funds.募资跟进.出资人跟进': '出资人跟进',
  'menu.funds.募资跟进.跟进详情': '跟进详情',
  'menu.funds.投资者关系': 'Investor Relations',
  'menu.funds.投资者关系.投资人关系': 'Investors',
  'menu.funds.投资者关系.缴款台账': 'Contribution Ledger',
  'menu.funds.投资者关系.投资人详情': 'Investor Detail',
  'menu.funds.投资者关系.出资详情': 'Contribution Detail',
  'menu.funds.缴款与到账': '认缴与实缴',
  'menu.funds.出资详情': '出资详情',
  'menu.investment.概览': '概览',
  'menu.investment.项目线索': '资源池',
  'menu.investment.客户关系': '客户关系',
  'menu.investment.客户关系.客户': '客户',
  'menu.investment.客户关系.organizationDetail': 'organizationDetail',
  'menu.investment.客户关系.联系人': '联系人',
  'menu.investment.leadDetail': 'leadDetail',
  'menu.investment.投资项目': '投资项目',
  'menu.investment.projectDetail': 'projectDetail',
  'menu.investment.投资决策': '投资决策',
  'menu.investment.审批工作台': '审批工作台',
  'menu.investment.decisionDetail': 'decisionDetail',
  'menu.investment.交易与交割': '交易与交割',
  'menu.investment.transactionDetail': 'transactionDetail',
  'menu.investment.台账报表': 'Ledger Reports',
  'menu.portfolio.概览': '概览',
  'menu.portfolio.投后管理': '投后管理',
  'menu.portfolio.投后项目': '投后项目',
  'menu.portfolio.投后管理.全部项目': '全部项目',
  'menu.portfolio.投后管理.我的项目': '我的项目',
  'menu.portfolio.投后管理.投后项目详情': '投后项目详情',
  'menu.portfolio.经营跟踪': '经营跟踪',
  'menu.portfolio.经营跟踪.经营看板': '经营看板',
  'menu.portfolio.经营跟踪.数据记录': '数据记录',
  'menu.portfolio.经营跟踪.记录详情': '记录详情',
  'menu.portfolio.风险与事项': '风险与事项',
  'menu.portfolio.风险与事项.风险台账': '风险台账',
  'menu.portfolio.风险与事项.风险详情': '风险详情',
  'menu.portfolio.风险与事项.重点事项': '重点事项',
  'menu.portfolio.风险与事项.事项详情': '事项详情',
  'menu.portfolio.定期报告': '定期报告',
  'menu.portfolio.定期报告.报告列表': '报告列表',
  'menu.portfolio.定期报告.报告详情': '报告详情',
  'menu.portfolio.exit.退出机会': '退出机会',
  'menu.portfolio.exit.机会详情': '机会详情',
  'menu.portfolio.exit.退出项目': '退出项目',
  'menu.portfolio.exit.项目详情': '项目详情',
  'menu.portfolio.exit.退出交易': '退出交易',
  'menu.portfolio.exit.交易详情': '交易详情',
  'menu.research.工作台': '工作台',
  'menu.research.产业研究': '产业研究',
  'menu.research.产业研究.产业专题': '产业专题',
  'menu.research.产业研究.研究资料': '研究资料',
  'menu.research.企业与标的': '企业与标的',
  'menu.research.机构与专家资源': '机构与专家资源',
  'menu.research.机构与专家资源.投资机构': '投资机构',
  'menu.research.机构与专家资源.专家': '专家',
  'menu.research.机构与专家资源.FA与服务机构': 'FA与服务机构',
  'menu.research.课题管理': '课题管理',
  'menu.research.课题管理.研究课题': '研究课题',
  'menu.数据看板': '数据看板',
  'menu.系统设置': '系统设置',
  'menu.系统设置.业务设置': '业务设置',
  'menu.设置': '设置',
  'menu.设置.业务字典': '业务字典',
  'menu.设置.业务配置': '业务配置',
  'menu.客户关系': '客户关系',
  'menu.客户关系.客户': '客户',
  'menu.客户关系.客户详情': '客户详情',
  'menu.客户关系.联系人': '联系人',
  'menu.home': '工作台',
  'menu.funds': '基金与募资',
  'menu.investment': '投资项目',
  'menu.portfolio': '投后与退出',
  'menu.portfolio.exit': '退出管理',
  'menu.research': '投研与资源',
  'menu.analysis': '分析与报告',
  'menu.settings.platform': '平台配置',
  'menu.workbench': 'workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.workItem': 'My Tasks',
  'menu.schedule': 'Schedule',
  'menu.focus': 'Focus',
  'menu.activity': 'Business Follow-ups & Alerts',
  'menu.overview': 'Overview',
  'menu.sourceDetail': 'Business Detail',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.settings': 'System Settings',
  'menu.settings.permissions': 'Permission Management',
  'menu.settings.modelSettings': 'Model Settings',
  'menu.settings.dictionaries': 'Business Dictionaries',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
